import { useAppTheme } from "@hooks/useAppTheme";
import { Box, ScrollContainer } from "@memorang/ui";
import type { ReactNode } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ProethicaCompletedProgressBar } from "./ProethicaCompletedProgressBar";

export const ProethicaReportShell = ({
	footer,
	children,
}: {
	footer: ReactNode;
	children: ReactNode;
}) => {
	const theme = useAppTheme();
	const insets = useSafeAreaInsets();
	return (
		<Box flex={1} backgroundColor={theme.colors.surface}>
			<Box
				style={{
					paddingTop: insets.top + 12,
					paddingBottom: 12,
					paddingHorizontal: 16,
				}}
			>
				<ProethicaCompletedProgressBar />
			</Box>
			<ScrollContainer
				style={{ flex: 1 }}
				contentContainerStyle={{
					paddingTop: 16,
					paddingBottom: 24,
					paddingHorizontal: 16,
				}}
			>
				<Box width="100%" maxWidth={1040} alignSelf="center" style={{ gap: 8 }}>
					{children}
				</Box>
			</ScrollContainer>
			<Box
				style={{
					borderTopWidth: 1,
					borderTopColor: theme.colors.outlineVariant,
					paddingTop: 12,
					paddingBottom: 12 + insets.bottom,
					paddingHorizontal: 16,
				}}
			>
				{footer}
			</Box>
		</Box>
	);
};
